import { Route, Routes } from 'react-router-dom'

import { AreaManagementContextProvider } from '@/context/AreaManagementContext'
import { DashboardContextProvider } from '@/context/DashboardContext'
import { MaintenanceTicketsContextProvider } from '@/context/MaintenanceTicketsContext'
import { UserManagementContextProvider } from '@/context/UserManagementContext'
import {
  AreaManagement,
  Credentials,
  Dashboard,
  Faq,
  Inbox,
  Logout,
  MaintenanceTickets,
  UserManagement,
} from '@/pages/index'
('@/assets/icons/notification.svg')

export const routes = [
  // {
  //   path: '/',
  //   page: (
  //     <MaintenanceTicketsContextProvider>
  //       <MaintenanceTickets />
  //     </MaintenanceTicketsContextProvider>
  //   ),
  //   name: 'Maintenance Tickets',
  //   icon: 'assets/icons/maintenance.svg',
  // },
  {
    path: '/dashboard',
    page: (
      <DashboardContextProvider>
        <Dashboard />
      </DashboardContextProvider>
    ),
    name: 'Dashboard',
    icon: 'assets/icons/dashboard.svg',
  },
  {
    path: '/',
    page: (
      <DashboardContextProvider>
        <Dashboard />
      </DashboardContextProvider>
    ),
    name: 'Dashboard',
    icon: 'assets/icons/dashboard.svg',
  },

  {
    path: '/maintenance-tickets',
    page: (
      <MaintenanceTicketsContextProvider>
        <MaintenanceTickets />
      </MaintenanceTicketsContextProvider>
    ),
    name: 'Maintenance Tickets',
    icon: 'assets/icons/maintenance.svg',
  },
  {
    path: '/area-management',
    page: (
      <AreaManagementContextProvider>
        <AreaManagement />
      </AreaManagementContextProvider>
    ),
    name: 'Area Management',
    icon: 'assets/icons/area-management.svg',
  },
  {
    path: '/user-management',
    page: (
      <UserManagementContextProvider>
        <UserManagement />
      </UserManagementContextProvider>
    ),
    name: 'User Management',
    icon: 'assets/icons/user-management.svg',
  },
  {
    path: '/faq',
    page: <Faq />,
    name: 'FAQs',
    icon: 'assets/icons/faq.svg',
  },
  {
    path: '/inbox',
    page: <Inbox />,
    name: 'Inbox',
    icon: 'assets/icons/inbox.svg',
  },
  {
    path: '/logout',
    page: <Logout />,
    name: 'Logout',
    icon: 'assets/icons/logout.svg',
  },
  {
  path: '/credentials',
  page: <Credentials />,
  name: 'Temporary Credentials',
  icon: 'assets/icons/credentials.svg', // optional
},


]
export const AppRoutes = () => {
  return (
    <Routes>
      {routes.map((route, index) => (
        <Route key={index} path={route.path} element={route.page} />
      ))}
      {/* add this on maintenance, you need 404 page for this website */}
      {/* <Route path="*" element={<NotFound />} /> */}
    </Routes>
  )
}
